// "Hear this voice" on the interview setup page (2026-10-30): plays the admin's
// sample phrase (Admin → Voice Check, step 1c) in the chosen interviewer voice.
export const VOICE_SAMPLE_STRINGS = {
  en: { hear: "Hear this voice", playing: "Playing…", error: "The voice sample couldn\u2019t be played. Please try again." },
  "pt-BR": { hear: "Ouvir esta voz", playing: "Reproduzindo…", error: "Não foi possível reproduzir a amostra de voz. Tente novamente." },
  "es-419": { hear: "Escuchar esta voz", playing: "Reproduciendo…", error: "No se pudo reproducir la muestra de voz. Inténtelo de nuevo." },
  "fr-CA": { hear: "Écouter cette voix", playing: "Lecture…", error: "Impossible de lire l\u2019échantillon de voix. Veuillez réessayer." },
};
